import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CardDetails } from '../models/order';
import { OrderService } from '../order.service';

export class PaymentOption{
  cash:boolean;
  card:boolean;
  storeCredit:boolean;
  cardDetail:CardDetails;
  storeCreditBalance:number;
  mobilePaymentService: boolean;

  constructor(cash:boolean, card:boolean, storeCredit:boolean,
      cardDetail:CardDetails, storeCreditBalance:number=0,mobilePaymentService=false){
    this.cash=cash;
    this.card=card;
    this.storeCredit=storeCredit;
    this.cardDetail=cardDetail;
    this.storeCreditBalance=storeCreditBalance;
    this.mobilePaymentService = mobilePaymentService;
  }

  hasPaymentOption(){
    // "card" only counts with the saved card behind it; a card flag with no detail is what let
    // Pay submit a null-card order that the backend then treated as cash.
    return this.cash || (this.card && !!this.cardDetail) || this.storeCredit || this.mobilePaymentService;
  }

  isMobilePaymentService(){
    this.mobilePaymentService = true;
  }
}

@Injectable()
export class PaymentOptionService{
  private source = new BehaviorSubject<PaymentOption>(null);
  current = this.source.asObservable();

  constructor(){}

  updatePaymentOption(paymentOption: PaymentOption) {
    if(paymentOption){
      this.source.next(paymentOption);
    }

  }
}
